<template>
    <div class="UserAudit">
        <div class="leftStructure" v-if="this.permission">
            <tree
                ref="tree"
                title="客户信息"
                :treeEdit="false"
                :showCheckbox="false"
                :sourceData="sourceData"
                :formatTreeData="jsonTree"
                :defExpandNode="[this.nodeId]"
                @clickTreeNode="clickTree"
                @freshTreeData="getTreeData">
            </tree>
        </div>
        <div class="centerStructure">
            <div class="searchBox">
                <span>姓名：</span>
                <el-input class="cname" clearable v-model.trim="searchForm.name" placeholder="请输入姓名"></el-input>
                <span class="inp">手机号码：</span>
                <el-input class="cname" clearable v-model.trim="searchForm.telephone" placeholder="请输入电话"></el-input>
                <span class="inp">状态：</span>
                <el-select class="cname" popper-class="selectWidth" v-model="searchForm.statusId" placeholder="全部"
                           filterable clearable>
                    <el-option class="wh140"
                               v-for="item in statusList"
                               :key="item.id"
                               :label="item.dictionaryName"
                               :value="item.id"
                    >
                    </el-option>
                </el-select>
                <span class="inp">申请日期：</span>
                <el-date-picker
                    v-model="searchForm.dateValue"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    size="small">
                </el-date-picker>
                <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                ref="singleTable"
                style="width: 100%"
                :default-sort="sortPorps"
                @sort-change="changeSort"
                height="calc(100% - 84px)">
                <el-table-column
                    fixed
                    header-align="center"
                    align="center"
                    type="index"
                    width="50">
                </el-table-column>
                <template v-for="item in tableTitle">
                    <el-table-column
                        :align="item.align"
                        header-align="center"
                        :key="item.index"
                        :label="item.label"
                        :prop="item.prop"
                        :formatter="item.formatter"
                        :width="item.width"
                        v-if="item.prop === 'operation'"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span class="tableicon" @click="update(scope)">编辑</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        :align="item.align"
                        header-align="center"
                        :key="item.index"
                        :label="item.label"
                        :prop="item.prop"
                        :formatter="item.formatter"
                        :width="item.width"
                        v-if="item.prop === 'customerName' && permission"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.customerName}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        :align="item.align"
                        header-align="center"
                        :key="item.index"
                        :label="item.label"
                        :prop="item.prop"
                        :formatter="item.formatter"
                        :sortable="item.sortable"
                        :width="item.width"
                        v-if="item.prop !== 'operation' && item.prop !== 'auditStatus' && item.prop !== 'customerName'"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        :align="item.align"
                        header-align="center"
                        :key="item.index"
                        :label="item.label"
                        :prop="item.prop"
                        :formatter="item.formatter"
                        :width="item.width"
                        :sortable="item.sortable"
                        v-if="item.prop === 'auditStatus'"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-tag
                                :type="scope.row.auditStatus === 1003003 ? 'danger' : scope.row.auditStatus === 1003004 ? 'success' : scope.row.auditStatus === 1003002 ? 'warning' : '' "
                                disable-transitions>{{ scope.row.auditStatusStr }}
                            </el-tag>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <!--分页数据-->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNumber"
                :page-sizes="[20, 50, 100]"
                :page-size="20"
                layout="total, sizes, prev, pager, next"
                :total="pageTotal">
            </el-pagination>
            <el-dialog
                ref="dialogAdd"
                :title="detailTitle"
                :visible.sync="detailOpenFlag"
                :close-on-click-modal="false"
                :modal-append-to-body="false"
                width="680px"
                class="dialogLoading"
            >
                <div class="formbox">
                    <el-form
                        :rules="detailRules"
                        :model="detailForm"
                        ref="detailRuleForm"
                        :label-position="labelPosition"
                        label-width="110px"
                        height="580px">
                        <div class="inline">
                            <el-form-item label="用户类型：">
                                <el-input v-model.trim="detailForm.userType" class="wh200" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item label="姓名：">
                                <el-input v-model.trim="detailForm.memberName" class="wh200"
                                          :disabled="true"></el-input>
                            </el-form-item>
                        </div>
                        <div class="inline">
                            <el-form-item label="手机号：">
                                <el-input v-model.trim="detailForm.telephone" class="wh200" :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item label="部门：">
                                <el-input v-model.trim="detailForm.department" class="wh200"
                                          :disabled="true"></el-input>
                            </el-form-item>
                        </div>
                        <div class="my-inline">
                            <el-form-item label="状态：" prop="status">
                                <el-select
                                    class="wh200"
                                    @change="changeStatus"
                                    v-model="detailForm.auditStatus"
                                    placeholder="请选择状态">
                                    <el-option
                                        class="wh200"
                                        v-for="item in statusList"
                                        :key="item.id"
                                        :label="item.dictionaryName"
                                        :value="item.id"
                                        :disabled="!item.enable"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="管理员：" prop="customType">
                              <el-radio-group v-model="detailForm.customType">
                                <el-radio border label="1">是</el-radio>
                                <el-radio border label="0">否</el-radio>
                              </el-radio-group>
                              <el-popover
                                  popper-class="icon-tips"
                                  trigger="hover"
                                  content="">
                                <div>
                                  管理员可在小程序查看当前客户所有设备数据，非管理员只能查看自己安装的设备。<br/>
                                </div>
                                <i slot="reference" class="tips-icon iconfont icon-tishi"></i>
                              </el-popover>
                            </el-form-item>
                        </div>
                        <el-form-item label="不通过原因：" prop="auditReason">
                            <el-input v-model.trim="detailForm.auditReason" :disabled="reasonFlag"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="detailOpenFlag = false">取 消</el-button>
                    <el-button type="primary" :loading=submitFlag
                               @click="submitForm('detailRuleForm')">提 交</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import {Mixins} from '@/config/mixins/mixins';
import {$http} from '@/config/api/axios';
import Tree from "@/components/common/Tree";
import {IsNull, timestampToTime} from "@/config/validate/common";
import {get_session_cache} from "@/config/cache/cache.js"

export default {
    name: "userAudit",
    mixins: [Mixins],
    components: {
        Tree,
    },
    data() {
        let checkReason = (rule, value, callback) => {
            if (IsNull(value) && !this.reasonFlag) {
                return callback(new Error('请输入未通过原因'));
            } else {
                callback();
            }
        };
        return {
            sortPorps: {
                prop: '',
                order: '',
            },
            sourceData: [],
            jsonTree: {
                id: "id",
                label: 'customerName',
                pcode: 'parentCode',
                code: 'code',
            },
            treeExpandNode: [],
            nodeId: '',
            searchForm: {
                name: '',
                telephone: '',
                statusId: '',
                beginDate: '',
                endDate: '',
                dateValue: ''
            },
            statusList: [],
            statusListDetail: [],
            tableData: [],
            tableTitle: [
                {prop: "operation", label: '操作', width: '80', align: 'center', show: true},
                {prop: "customerName", label: '客户名称', width: '200', align: 'center', show: true},
                {prop: "userType", label: '用户类型', width: '120', align: 'center', show: true},
                {prop: "memberName", label: '姓名', width: '', align: 'left', show: true},
                {prop: "telephone", label: '手机号码', width: '140', align: 'center', show: true},
                {prop: "department", label: '部门', width: '', align: 'center', show: true},
                {prop: "auditStatus", label: '状态', width: '100', align: 'center', show: true, sortable: true},
                {prop: "createTime", label: '申请时间', width: '160', align: 'center', show: true, sortable: true},
                {prop: "auditUserName", label: '审核人', width: '100', align: 'center', show: true},
                {prop: "auditTime", label: '审核时间', width: '160', align: 'center', show: true, sortable: true},
            ],
            pageSize: 20, //条数
            pageNumber: 1,
            pageTotal: 0, //总页数
            detailRules: {
                auditReason: [
                    {max: 20, message: '长度不超过20个字符', trigger: 'blur'},
                    {validator: checkReason, trigger: 'blur'},
                ],
            },
            detailForm: {
                id: "",
                userType: "",
                memberName: "",
                telephone: "",
                department: "",
                auditStatus: "",
                auditReason: "",
                customType: "0",
            },
            detailTitle: "详情",
            detailOpenFlag: false,
            labelPosition: 'right',
            reasonFlag: true,
            submitFlag: false,
            midReason: '',
            permission: false,
        }
    },
    methods: {
        //分页方法
        handleSizeChange(val) {
            this.pageSize = val;
            this.handleCurrentChange(1);
        },
        handleCurrentChange(val) {
            this.pageNumber = val;
            this.getList();
        },
        //获取树
        getTreeData() {
            this.sourceData = [];
            this.selfLoadingOpen('.userAudit');
            $http("get", "/wechat/customer/getCustomerTree").then((res) => {
                if (res.status === 'SUCCESS') {
                    this.sourceData = Object.freeze(res.data);
                } else {
                    this.sourceData = [];
                }
                this.selfLoadingClose();
            });
        },
        //点击树
        clickTree(data) {
            let id = data.id;
            this.nodeId = id;
            this.getList(id);
        },
        //查询
        search() {
            this.handleCurrentChange(1);
        },
        //获取列表
        getList() {
            this.tableData = [];
            if (this.searchForm.dateValue !== "" && this.searchForm.dateValue != null) {
                this.searchForm.beginDate = Math.floor(this.searchForm.dateValue[0] / 1000);
                this.searchForm.endDate = Math.ceil(this.searchForm.dateValue[1] / 1000)
            } else {
                this.searchForm.beginDate = null;
                this.searchForm.endDate = null;
            }
            let params = {
                customerId: this.nodeId,
                name: this.searchForm.name,
                telephone: this.searchForm.telephone,
                pageSize: this.pageSize,
                pageNumber: this.pageNumber,
                statusId: this.searchForm.statusId,
                beginDate: this.searchForm.beginDate,
                endDate: this.searchForm.endDate
            };
            this.selfLoadingOpen('.UserAudit');
            $http("get", "userAudit/listUserAudit", params)
                .then((res) => {
                    if (res.status === 'SUCCESS') {
                        if (this.sortPorp !== '') { // 说明点击过排序了
                            this.sortPorps = {prop: this.sortPorp, order: ''}
                            this.sortPorp = '';
                        }
                        this.tableData = res.data;
                        this.pageTotal = res.count;
                    } else if (res.status === 'NORESOURCES') {
                        this.tableData = [];
                        this.pageTotal = res.count;
                    } else {
                        this.msgerror(res.message);
                    }
                    this.selfLoadingClose();
                });
        },
        update(scope) {
            this.detailOpenFlag = true;
            this.getUserAudit(scope.row.id);
            this.$nextTick(() => {
                this.$refs['detailRuleForm'].resetFields();
            })
        },
        getUserAudit(id) {
            let param = {id: id};
            $http("get", "userAudit/getUserAudit", param)
                .then((res) => {
                    if (res.status === 'SUCCESS') {
                        this.detailForm.id = res.data.id;
                        this.detailForm.userType = res.data.userType;
                        this.detailForm.memberName = res.data.memberName;
                        this.detailForm.telephone = res.data.telephone;
                        this.detailForm.department = res.data.department;
                        this.detailForm.auditStatus = res.data.auditStatus;
                        this.detailForm.auditReason = res.data.auditReason;
                        if (res.data.customType) {
                          this.detailForm.customType = res.data.customType + "";
                        }
                        this.midReason = this.detailForm.auditReason;
                        if (this.detailForm.auditStatus === 1003002) {
                            //待审核
                            this.statusList[0].enable = true;
                            this.reasonFlag = true;
                        } else if (this.detailForm.auditStatus === 1003003) {
                            //审核未通过
                            this.statusList[0].enable = false;
                            this.reasonFlag = false;
                        } else if (this.detailForm.auditStatus === 1003004) {
                            //审核通过
                            this.statusList[0].enable = false;
                            this.reasonFlag = true;
                        }
                    } else {
                        this.msgerror(res.message);
                    }
                    this.selfLoadingClose();
                });
        },
        submitForm(ref) {
            this.$refs[ref].validate((valid) => {
                if (valid) {
                    let params = {
                        id: this.detailForm.id,
                        auditStatus: this.detailForm.auditStatus,
                        auditReason: this.detailForm.auditReason,
                        customType: this.detailForm.customType,
                    };
                    this.submitFlag = true;
                    $http("POST", "userAudit/updateUserAudit", params)
                        .then((res) => {
                            this.submitFlag = false;
                            if (res.status === 'SUCCESS') {
                                this.detailOpenFlag = false;
                                this.msgsuccess(res.message);
                                this.getList();
                            } else {
                                this.msgerror(res.message);
                            }
                        })
                }
            })
        },
        //获取状态下拉框值
        getStatusList() {
            let param = {
                typeId: 1003,
            };
            $http("get", "dictionary/listDictionaryByTypeId", param)
                .then((res) => {
                    if (res.status === 'SUCCESS') {
                        for (let i = 0; i < res.data.length; i++) {
                            this.statusList.push(res.data[i]);
                        }
                    }
                })
        },
        changeStatus() {
            if (this.detailForm.auditStatus === 1003003) {
                this.detailForm.auditReason = this.midReason;
                this.reasonFlag = false;
            } else {
                this.midReason = this.detailForm.auditReason;
                this.detailForm.auditReason = '';
                this.reasonFlag = true;
                this.$refs.detailRuleForm.clearValidate();
            }
        },
        //获取当前用户权限
        getPermission() {
            //为平台管理员时  左侧需要显示客户树
            if (get_session_cache('loginType') === '1008001') {
                this.permission = true;
                this.getTreeData();
            } else {
                this.permission = false;
            }
        },
        changeSort(column) {
            if (this.tableData === 0) {
                return
            }
            //赋值该列的prop属性
            this.sortPorp = column.prop;
            if (column.order === "descending") {
                //降序
                this.tableData.sort(this.desc_sort)
            } else if (column.order === "ascending") {
                //升序
                this.tableData.sort(this.asc_sort)
            }
            this.tableData.forEach((item) => {
                if (item[column.prop] === -Infinity || item[column.prop] === Infinity) {
                    item[column.prop] = '';
                }
            })
        }
    },
    created() {
        this.getStatusList();
        this.getList();
        this.getPermission();
    },
    activated() {
        this.$refs.singleTable.doLayout()
    }
}
</script>

<style lang="less">
.UserAudit {
    width: 100%;
    height: 100%;
    margin-bottom: 10px;
    display: flex;
    position: relative;

    .el-dialog__body {
        padding-right: 20px;
    }

    .formbox{
      .my-inline{
        display: flex;
      }
    }
}
</style>